import { TEXT_SIZE, OLD_TEXT_SIZE } from './AnswerTypes.const'

export const getFontScale = (value, withOldSize = false) => {
	const sizes = withOldSize ? OLD_TEXT_SIZE : TEXT_SIZE

	return sizes[value] || sizes.default
}
